'use client';

import type { ReactNode } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

import { Footer } from '@/components/design-system/Footer/Footer';
import { Navigation } from '@/components/design-system/Navigation/Navigation';
import { ThemeToggle } from '@/components/design-system/ThemeToggle/ThemeToggle';

const DONOVAN_SOURCE = 'donovan';
const LEGAL_PATHS = new Set([
  '/mentions-legales',
  '/politique-de-confidentialite',
  '/cgv',
]);

type AppChromeProps = {
  children: ReactNode;
};

export function AppChrome({ children }: AppChromeProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isMinimalLegalView =
    LEGAL_PATHS.has(pathname) && searchParams.get('source') === DONOVAN_SOURCE;

  return (
    <>
      {!isMinimalLegalView && <Navigation />}
      {isMinimalLegalView && (
        <div className="fixed top-4 right-4 z-50">
          <ThemeToggle size="sm" />
        </div>
      )}
      <main id="main-content" className="flex-1">
        {children}
      </main>
      {!isMinimalLegalView && <Footer />}
    </>
  );
}
